import { useSelector } from "react-redux";
import { selectNavItems } from "state/selectors/Selectors";

interface DropdownMenuProps {
  menuClassName?: string;
  itemClassName?: string;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  menuClassName = "",
  itemClassName = "",
}) => {
  const items = useSelector(selectNavItems);

  return (
    <div className="relative">
      <div className={`${menuClassName}`} role="menu" aria-orientation="vertical">
        {items
          .filter(item => item.ParentId == null)
          .map(item => (
            <a
              key={item.ID}
              href={item.Link?.Url || "#"}
              className={`text-white! hover:bg-[#003d4c] no-underline! ${itemClassName}`}
              role="menuitem"
              rel="noopener noreferrer"
            >
              {item.Title}
            </a>
          ))}
      </div>
    </div>
  );
};

export default DropdownMenu;